/**
 * We should pass environment variables during app build process.
 * Now we have the following configuration for different environments:
 * Development - use 'env.development' file for env variables;
 * Production - env variables are provided in CI.
 */
export const environment = {
  production: import.meta.env.NG_APP_ENV === 'production',
  apiUrl: import.meta.env.NG_APP_API_URL,
  country: import.meta.env.NG_APP_COUNTRY,
  googleAnalytics: import.meta.env.NG_APP_GOOGLE_ANALYTICS_KEY,
  baiduKey: import.meta.env.NG_APP_BAIDU_ANALYTICS_KEY,
};
